import { StyleRulesCallback } from '@material-ui/core';

const styles: StyleRulesCallback = theme => ({
  root: {},
});

export default styles;



// WEBPACK FOOTER //
// ./src/screens/Reviews/styles.tsx